<p-button
  [type]="type"
  [disabled]="isDisabled"
  [label]="displayText"
  [loading]="loading"
  [ngClass]="buttonClass + ' ' + (isDisabled ? disabledClass : '')"
  (onClick)="onClick()"
></p-button>
